// src/pages/admin/dashboard/components/RecentAuditionsList.js
import React from "react";
import { Col, Card, Badge, ProgressBar } from "react-bootstrap";

const RecentAuditionsList = ({ auditions }) => {
  return (
    <Col lg={5}>
      <Card className="dashboard-table-card h-100">
        <Card.Body>
          <h5 className="chart-title mb-4">
            Recent Auditions
          </h5>

          <div className="recent-auditions-scroll">
            {auditions.map((item, index) => (
              <div key={index} className="audition-item">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6>
                      {item.candidateName}
                    </h6>

                    <p className="audition-subtext">
                      {item.roleName} • {item.castingDirector}
                    </p>
                  </div>

                  <Badge
                    bg={
                      item.status === "Selected"
                        ? "success"
                        : item.status === "Shortlisted"
                        ? "warning"
                        : item.status === "Rejected"
                        ? "danger"
                        : "secondary"
                    }
                  >
                    {item.status || "Pending"}
                  </Badge>
                </div>

                <ProgressBar
                  now={
                    item.status === "Selected"
                      ? 100
                      : item.status === "Shortlisted"
                      ? 70
                      : item.status === "Pending"
                      ? 40
                      : 20
                  }
                  variant="danger"
                  className="mt-2"
                />
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default RecentAuditionsList;
